const LANGUAGE = [
  {
    name: 'en',
    value: 'en',
  },
  {
    name: 'ar',
    value: 'ar',
  },
  {
    name: 'fr',
    value: 'fr',
  },
  {
    name: 'es',
    value: 'es',
  },
  {
    name: 'pt',
    value: 'pt',
  },
  {
    name: 'sw',
    value: 'sw',
  },
  {
    name: 'am',
    value: 'am',
  },
];

export const COMMON_LANGUAGE_OPTIONS = (window?.__WKD_COMMON_ENUMS__?.language || LANGUAGE).map(
  ({ name, value }) => ({
    label: name,
    value,
    name,
  }),
);
